<ng-template #streamStatsModal class="stream-stats-modal" let-c="close" let-d="dismiss">
    <a (click)="d('Cross click')" data-cy="close-modal" class="stream-stats-modal__close-btn" title="Close Stream Modal">
        <svg id="Capa_1" enable-background="new 0 0 413.348 413.348" height="512" viewBox="0 0 413.348 413.348" width="512" xmlns="http://www.w3.org/2000/svg"><path d="m413.348 24.354-24.354-24.354-182.32 182.32-182.32-182.32-24.354 24.354 182.32 182.32-182.32 182.32 24.354 24.354 182.32-182.32 182.32 182.32 24.354-24.354-182.32-182.32z"/></svg>
    </a>
    <h2 class="stream-stats-modal__title">
        {{stream.name}} stream stats 
    </h2>
    <div class="stream-stats-modal__params">
        <div class="stream-stats-modal__params__input-holder">
            <label class="stream-stats-modal__params__input-holder__label">Content type:</label>
            <notd-dropdown
                [buttonLabel]="chartParams.paid ? chartParams.paid : 'Select content type'"
                [objectConvert]="{value: 'value', label: 'label', selected: 'selected'}"
                (elementSelected)="selectChartParam('paid', $event)"
                [options]="paramsData.paid">
            </notd-dropdown>
        </div>
        <div class="stream-stats-modal__params__input-holder">
            <label class="stream-stats-modal__params__input-holder__label">Time period:</label>
            <notd-dropdown
                [buttonLabel]="chartParams.interval ? chartParams.interval : 'Select time period'"
                [objectConvert]="{value: 'value', label: 'label', selected: 'selected'}"
                (elementSelected)="selectChartParam('interval', $event)"
                [options]="paramsData.interval">
            </notd-dropdown>
        </div>
        <div class="stream-stats-modal__params__input-holder">
            <label class="stream-stats-modal__params__input-holder__label">Date From:</label>
            <input class="form-control"
                class="notd__datepicker"
                autocomplete="off"
                placeholder="yyyy-mm-dd"
                [value]="chartParams.from.value ? formatter.format(chartParams.from.value) : ''"
                (click)="datepicker.toggle()"
                name="dpf"
                #dpf>
        </div>
        <div class="stream-stats-modal__params__input-holder position--relative">
            <div class="stream-stats-modal__params__input-holder__range-dp-wrapper">
                <input name="datepicker"
                    class="form-control"
                    ngbDatepicker
                    #datepicker="ngbDatepicker"
                    [autoClose]="'outside'"
                    (dateSelect)="selectChartParam('range', $event, datepicker)"
                    [displayMonths]="2"
                    [dayTemplate]="t"
                    outsideDays="hidden"
                    [startDate]="chartParams.from.value!"
                    tabindex="-1">
                <ng-template #t let-date let-focused="focused">
                <span class="custom-day"
                    [class.focused]="focused"
                    [class.range]="isRange(date)"
                    [class.faded]="isHovered(date) || isInside(date)"
                    (mouseenter)="hoveredDate = date"
                    (mouseleave)="hoveredDate = null">
                    {{ date.day }}
                </span>
                </ng-template>
            </div>
            <label class="stream-stats-modal__params__input-holder__label">Date To:</label>
            <input class="form-control"
                class="notd__datepicker"
                placeholder="yyyy-mm-dd"
                autocomplete="off"
                [placement]="'bottom-right'"
                [value]="chartParams.to.value ? formatter.format(chartParams.to.value) : ''"
                (click)="datepicker.toggle()"
                name="dpt"
                #dpt>
        </div>
    </div>
    <section class="stream-stats-modal__chart">
        <div class="stream-stats-modal__chart__loading" *ngIf="!chartLoaded">
            <span class="stream-stats-modal__chart__loading__spinner"></span>
            <p class="stream-stats-modal__chart__loading__label">Loading chart data...</p>
        </div>
        <div
            class="stream-stats-modal__chart__wrapper"
            echarts
            (chartFinished)="chartEvent('finished')"
            (chartRendered)="chartEvent('rendered')"
            [options]="options">
        </div>
    </section>
    <section class="stream-stats-modal__buttons">
        <button type="button"
            (click)="closeModal()"
            class="notd__button--v2 button--black">
                Close Modal
        </button>
    </section>
</ng-template>